/**
 * @generated SignedSource<<75c6e4863f430f82d85ef6e4e74ec1ae>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type desktopRecorderApiRecorderEndLocalRecordingMutation$variables = {
  audioUrl: string;
  meetingRecordingId: string;
};
export type desktopRecorderApiRecorderEndLocalRecordingMutation$data = {
  readonly endLocalRecording: {
    readonly ok: boolean;
  } | null;
};
export type desktopRecorderApiRecorderEndLocalRecordingMutation = {
  response: desktopRecorderApiRecorderEndLocalRecordingMutation$data;
  variables: desktopRecorderApiRecorderEndLocalRecordingMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "audioUrl"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "meetingRecordingId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "audioUrl",
        "variableName": "audioUrl"
      },
      {
        "kind": "Variable",
        "name": "meetingRecordingId",
        "variableName": "meetingRecordingId"
      }
    ],
    "concreteType": "EndLocalRecording",
    "kind": "LinkedField",
    "name": "endLocalRecording",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "desktopRecorderApiRecorderEndLocalRecordingMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "desktopRecorderApiRecorderEndLocalRecordingMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "4d80fb0e79e54a7dc0d7c52951a48ab8",
    "id": null,
    "metadata": {},
    "name": "desktopRecorderApiRecorderEndLocalRecordingMutation",
    "operationKind": "mutation",
    "text": "mutation desktopRecorderApiRecorderEndLocalRecordingMutation(\n  $meetingRecordingId: ID!\n  $audioUrl: String!\n) {\n  endLocalRecording(meetingRecordingId: $meetingRecordingId, audioUrl: $audioUrl) {\n    ok\n  }\n}\n"
  }
};
})();

(node as any).hash = "424efdb06cbec34e8d63d9b81924c245";

export default node;
